// extracted by mini-css-extract-plugin
export var container = "R_b";
export var device = "R_dH";
export var deviceContainer = "R_dG";
export var icon = "R_bz";
export var icons = "R_cW";
export var image = "R_k";
export var logo = "R_bn";
export var model = "R_dJ";
export var section = "R_j";